import React, { useCallback, useMemo, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { toBlob } from 'html-to-image'
import { Spin } from 'antd'

import Navbar from '../Navbar/Navbar'
import FarmerReport1 from '../../../../assets/images/farmer-report-1.svg'
import PhoneSent from '../../../../assets/images/phone-sent.png'
import WhatsAppIcon from '../../../../assets/images/whatsapp.png'
import ReportIcon from '../../../../assets/images/bx_bx-chart.png'
import { api, request } from '../../../../util/handlerRequestUtil'

import './Styles.css'

const PortalLayout = ({
  history,
  children,
  centerImage,
  bgImage,
  title,
  subtitle,
  centerImageHeight = '120px',
  showAction = false
}) => {
  const currentUser = useSelector((state) => state.auth.auth)
  const [showModal, setShowModal] = useState(false)
  const [sending, setSending] = useState(false)

  const ref = React.createRef()

  const onButtonClick = useCallback(() => {
    if (ref.current === null) {
      return
    }

    setSending(true)
    setShowModal(true)

    /*
    Applies attributes to correct the rendering of the report image. The image builder
    takes a screenshot of the page with the current styles and can create an image
    without some information.
     */
    const report = ref.current.children[0]
    report.style.width = '630px'
    report.style.height = '900px'
    report.classList.add('hideScrollBar')

    const logo = document.createElement('div')
    logo.classList.add('modal-logo')

    const child = report.firstChild
    report.insertBefore(logo, child)

    toBlob(report, {
      cacheBust: true,
      backgroundColor: '#ffffff',
      width: 630,
      height: 900,
      canvasWidth: 630,
      canvasHeight: 900
    })
      .then(async (dataUrl) => {
        const data = new FormData()
        data.append('file', dataUrl)
        const response = await request(api.uploadAttachment(data), true)

        await request(
          api.sendFarmReport({
            phone: currentUser.phone,
            image: response.fileUri
          }),
          true
        )

        /*
        Removes the applied attributes to show the page with original styles.
         */
        report.style.width = 'auto'
        report.style.height = 'auto'
        report.classList.remove('hideScrollBar')
        report.removeChild(report.childNodes[0])
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => setSending(false))
  }, [ref])

  const sendingReportModal = useMemo(() => {
    return (
      showModal && (
        <div className="sending-report-modal">
          <div className="modal-logo" />
          <div className="modal-content">
            <img className="modal-image" src={PhoneSent} alt="smartphone" />

            {sending ? (
              <div className="modal-container">
                <p className="modal-title">Aguarde... Estamos enviando o relatório para seu WhatsApp!</p>
                <Spin className="modal-spin" size="large" />
              </div>
            ) : (
              <div className="modal-container">
                <p className="modal-title">Pronto!</p>
                <p className="modal-title">Seu relatório foi enviado para o seu WhatsApp!</p>

                <button className="modal-button" onClick={() => setShowModal(false)}>
                  Voltar ao Relatório
                </button>
              </div>
            )}
          </div>
        </div>
      )
    )
  }, [showModal, sending])

  return (
    <div className="portal-layout" style={{ overflow: showModal ? 'hidden' : 'unset' }}>
      <div className="desktop-navbar">
        <Navbar />
      </div>

      {sendingReportModal}

      <div className="layout-container">
        <div className="banner">
          {bgImage && <img className="bg-image" src={bgImage} alt="gb-images" />}
          <div className="portal-logo" />
          <img
            className="farmer-image"
            style={{ height: centerImageHeight }}
            src={centerImage || FarmerReport1}
            alt="farmer-images or farmer-pictures"
          />
          <p className="layout-title">{title || 'Bem-vindo ao portal de relatórios do agricultor'}</p>
          {subtitle && <p className="layout-subtitle">{subtitle}</p>}
        </div>

        <div ref={ref} className="layout-content">
          {children}

          {showAction && (
            <div className="report-actions">
              <button className="button wpp-btn" onClick={onButtonClick}>
                <img className="btn-icon" src={WhatsAppIcon} alt="whatsapp-icon" />
                Enviar no WhatsApp
              </button>
              <button className="button report-btn" onClick={() => history.push('/farmers/reports')}>
                <img className="btn-icon" src={ReportIcon} alt="whatsapp-icon" />
                Novo relatório
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default withRouter(PortalLayout)
